import {Outlet, Route, Routes, Navigate} from "react-router-dom";
import Tournaments from "../pages/tournaments";
import TouranamentList from "../pages/tournametList";
import Match from "../pages/matchCard";
import SingleMatch from "../pages/matchCard";
import ShareableMatch from "../pages/shareableMatch";
import {useEffect} from "react";

const ExternalRedirect = () => {
    useEffect(() => {
        window.location.href = "https://home.scorebuzzer.com/";
    }, []);

    return null;
};

export const Routers = () => {
    const port = process.env.PORT || 3000;

    return (
        <Routes>
            <Route path="/" element={<ExternalRedirect/>}/>
            <Route path="tennis/matches/:matchuuid" element={<ShareableMatch/>}/>
            <Route path="matches/:matchuuid" element={<ShareableMatch/>}/>
            <Route path=":tournament_slug" element={<Tournaments/>}/>
            <Route path=":tournament_slug/matches/:matchuuid" element={<SingleMatch/>}/>
        </Routes>
    );
};
